import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "grid m-2" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "flex justify-content-between" }
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = {
  key: 0,
  class: "pi pi-check"
}
const _hoisted_6 = {
  key: 1,
  class: "pi pi-times"
}
const _hoisted_7 = {
  key: 0,
  class: "pi pi-check"
}
const _hoisted_8 = {
  key: 1,
  class: "pi pi-times"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "pi pi-check"
}
const _hoisted_12 = {
  key: 1,
  class: "pi pi-times"
}
const _hoisted_13 = { class: "grid formgrid" }
const _hoisted_14 = { class: "col-12 md:col-6 field p-fluid" }
const _hoisted_15 = { class: "col-12 md:col-6 field p-fluid" }
const _hoisted_16 = { class: "col-12 field p-fluid" }
const _hoisted_17 = { class: "col-12 md:col-4 field-checkbox" }
const _hoisted_18 = { class: "col-12 md:col-4 field-checkbox" }
const _hoisted_19 = { class: "col-12 md:col-4 field-checkbox" }
const _hoisted_20 = { class: "col-12 p-fluid field" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Card, null, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _cache[10] || (_cache[10] = _createTextVNode(" จัดการ User ")),
              _createVNode(_component_Button, {
                label: "สร้างใหม่",
                class: "p-button-success",
                icon: "pi pi-plus",
                onClick: _ctx.onNew
              }, null, 8, ["onClick"])
            ])
          ]),
          content: _withCtx(() => [
            _createVNode(_component_DataTable, {
              value: _ctx.filteredUsers,
              responsiveLayout: "scroll",
              filterDisplay: "menu",
              dataKey: "userId",
              scrollable: "",
              scrollHeight: "60vh",
              class: "p-datatable-sm",
              loading: _ctx.isLoading
            }, {
              header: _withCtx(() => [
                _createElementVNode("span", _hoisted_4, [
                  _createVNode(_component_InputText, {
                    id: "searchString",
                    modelValue: _ctx.searchString,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchString) = $event)),
                    class: "p-inputtext-sm"
                  }, null, 8, ["modelValue"]),
                  _cache[11] || (_cache[11] = _createElementVNode("label", { for: "searchString" }, "ค้นหา", -1))
                ])
              ]),
              empty: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode(" ไม่พบข้อมูล ")
              ])),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "userId",
                  header: "User Id",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "adUser",
                  header: "AD User",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "name",
                  header: "Name",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "deliverAuthority",
                  header: "สิทธิการใช้งาน Mobile App"
                }, {
                  body: _withCtx((props) => [
                    (props.data.deliverAuthority)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                      : (_openBlock(), _createElementBlock("i", _hoisted_6))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "reportAuthority",
                  header: "สิทธิการดูรายงาน",
                  sortable: ""
                }, {
                  body: _withCtx((props) => [
                    (props.data.reportAuthority)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                      : (_openBlock(), _createElementBlock("i", _hoisted_8))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "salesOfficeAuthority",
                  header: "สำนักงานขายที่มีสิทธิ",
                  sortable: ""
                }, {
                  body: _withCtx((props) => [
                    (props.data.salesOfficeAuthority?.length <= 20)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(props.data.salesOfficeAuthority), 1))
                      : _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_10, [
                          _createTextVNode(_toDisplayString(`${props.data.salesOfficeAuthority.substring(0, 20)}...`), 1)
                        ])), [
                          [_directive_tooltip, 
                    `${props.data.salesOfficeAuthority?.replaceAll(',', ', ')}`
                  ]
                        ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "adminAuthority",
                  header: "สิทธิ Admin",
                  sortable: ""
                }, {
                  body: _withCtx((props) => [
                    (props.data.adminAuthority)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                      : (_openBlock(), _createElementBlock("i", _hoisted_12))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, { headerStyle: "width:4rem" }, {
                  body: _withCtx((props) => [
                    _createVNode(_component_Button, {
                      icon: "pi pi-pencil",
                      class: "p-button-rounded p-button-warning",
                      onClick: ($event: any) => (_ctx.onEdit(props.data))
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["value", "loading"])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showPopup,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showPopup) = $event)),
      header: "ข้อมูล User",
      modal: ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          icon: "pi pi-check",
          label: "ตกลง",
          class: "p-button-success",
          onClick: _ctx.onSubmit
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          icon: "pi pi-times",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showPopup = false)),
          label: "ยกเลิก",
          class: "p-button-danger"
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _cache[13] || (_cache[13] = _createElementVNode("label", { for: "userId" }, "User Id (84xxxxxx)", -1)),
            _createVNode(_component_InputText, {
              id: "userId",
              modelValue: _ctx.user.userId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.userId) = $event)),
              readonly: _ctx.editMode
            }, null, 8, ["modelValue", "readonly"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[14] || (_cache[14] = _createElementVNode("label", { for: "adUser" }, "Ad User", -1)),
            _createVNode(_component_InputText, {
              id: "adUser",
              modelValue: _ctx.user.adUser,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.adUser) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[15] || (_cache[15] = _createElementVNode("label", { for: "name" }, "Name", -1)),
            _createVNode(_component_InputText, {
              id: "name",
              modelValue: _ctx.user.name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.name) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_Checkbox, {
              id: "deliver",
              binary: "",
              modelValue: _ctx.user.deliverAuthority,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.deliverAuthority) = $event))
            }, null, 8, ["modelValue"]),
            _cache[16] || (_cache[16] = _createElementVNode("label", { for: "deliver" }, "สิทธิการใช้งาน POD", -1))
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_Checkbox, {
              id: "reportAuth",
              binary: "",
              modelValue: _ctx.user.reportAuthority,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user.reportAuthority) = $event))
            }, null, 8, ["modelValue"]),
            _cache[17] || (_cache[17] = _createElementVNode("label", { for: "reportAuth" }, "สิทธิการดูรายงาน", -1))
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createVNode(_component_Checkbox, {
              id: "admin",
              binary: "",
              modelValue: _ctx.user.adminAuthority,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user.adminAuthority) = $event))
            }, null, 8, ["modelValue"]),
            _cache[18] || (_cache[18] = _createElementVNode("label", { for: "admin" }, "สิทธิ Admin", -1))
          ])), [
            [
              _directive_tooltip,
              `สามารถแก้ไขผู้ใช้งานได้`,
              void 0,
              { bottom: true }
            ]
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[19] || (_cache[19] = _createElementVNode("label", { for: "salesoffice" }, "ระบุ Sales Office ที่สามารถดูรายงานได้", -1)),
            _withDirectives(_createVNode(_component_Textarea, {
              id: "salesoffice",
              modelValue: _ctx.user.salesOfficeAuthority,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.user.salesOfficeAuthority) = $event))
            }, null, 8, ["modelValue"]), [
              [
                _directive_tooltip,
                
            `ระบุ Sales office ที่สามารถดูรายงานได้ คั่นด้วย , เช่น 9201,9202,9203 เป็นต้น`
          ,
                void 0,
                { bottom: true }
              ]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}